import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { palette } from 'c1ui'

export const useStyles = makeStyles(() => {
    return createStyles({
        rectangle: {
            backgroundColor: palette.background.default,
            border: `1px solid ${palette.border.subtle}`,
            borderRadius: 6,
            display: 'flex',
        },
    })
})
